import { P2GDropdown, P2GGrid } from '@parcel2go/core-ui';
import { Country } from '~/lib/api/smartsend/types';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

interface props {
  value: string;
  onChange: (value: string) => void;
  countries: Country[];
  disabled?: boolean;
  required?: boolean;
}

export const CountryOfManufactureField: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  return (
    <P2GGrid item xs={12}>
      <P2GDropdown
        key={`${props.countries.length}`}
        id="Manufactured In"
        label={t('MANUFACTURED_IN_INPUT_LABEL', { defaultValue: 'Manufactured In' })}
        onChange={(v) => props.onChange(String(v))}
        options={props.countries.map((x) => ({ label: x.LocalisedName, value: x.Name }))}
        required={props.required}
        disabled={props.disabled}
        value={props.value || ''}
      />
    </P2GGrid>
  );
};
